import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/EmailAddress.svg'

export const IconEmailAddress = IconSVG as IconComponent
